export default __webpack_public_path__ + "icon-arrow-right.svg";